module.exports = __webpack_public_path__ + "img/default.1c656be9.svg";